<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <h6 class="modal-title" i18n>Automations</h6>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="container-box">
        <app-automations-table viewType="list" tableType="Automations" [showActions]="true" (rowClick)="onLogs($event)">
        </app-automations-table>
      </div>
    </div>
  </div>
</div>
